var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkAccountErrorM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8049 12.5721L8.8309 0.588977C8.37399 -0.196326 7.62609 -0.196326 7.16901 0.588977L0.194992 12.5721C-0.261918 13.3576 0.111948 14 1.02611 14H14.9741C15.888 14 16.262 13.3576 15.8049 12.5721ZM8.0208 11.8485H8.01038C7.56204 11.8485 7.22835 11.5178 7.22835 11.0316C7.22835 10.5663 7.56204 10.2249 8.0208 10.2249C8.47956 10.2249 8.81325 10.5663 8.81325 11.0316C8.81325 11.5178 8.47956 11.8485 8.0208 11.8485ZM8.75072 6.04657C8.55269 7.15324 8.39618 8.27024 8.23985 9.45945C8.20858 9.58352 7.78109 9.5942 7.76007 9.45945C7.6039 8.27024 7.43714 7.15324 7.23878 6.04657C7.17624 5.65367 7.14497 5.46723 7.14497 5.29162C7.14497 5.04331 7.32233 4.84686 7.99996 4.84686H8.01021C8.65675 4.84686 8.85478 5.04331 8.85478 5.29162C8.85494 5.46723 8.81325 5.65367 8.75072 6.04657Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAccountErrorM);
export default __webpack_public_path__ + "static/media/link_account_errorM.4c041a33fe5ef1bfa3617e82e99d36e4.svg";
export { ForwardRef as ReactComponent };